import Dashboard from "../Pages/Teachers/Dashboard/Dashboard";
import Profile from "../Pages/Profile/Profile";
import SchoolsListing from "../Pages/Common/Schools/SchoolsListing/SchoolsListing";
import ClassesAndCourses from "../Pages/Admin/ClassesAndCourses/ClassesAndCourses";
import CoursesListing from "../Pages/Admin/ClassesAndCourses/CoursesListing/CoursesListing";
import Attendance from "../Pages/Admin/Attendance/Attendance";
import AddAttendance from "../Pages/Admin/Attendance/AddAttendance/AddAttendance";
import PreviousAttendance from "../Pages/Admin/Attendance/PreviousAttendance/PreviousAttendance";
import ExamListing from "../Pages/Admin/ClassesAndCourses/Exams/ExamListing/ExamListing";
import AddExam from "../Pages/Admin/ClassesAndCourses/Exams/AddExam/AddExam";
import AddResult from "../Pages/Admin/Results/AddResult/AddResult";
import ExamResult from "../Pages/Admin/Results/ExamResult/ExamResult";
import SportsListing from "../Pages/Common/Sports/SportsListing/SportsListing";
import RoomsListing from "../Pages/Common/Hostel/RoomsListing/RoomsListing";
import TransportsListing from "../Pages/Common/Transports/TransportsListing/TransportsListing";
import HolidaysListing from "../Pages/Common/Holidays/HolidaysListing/HolidaysListing";
import SchoolLibraryListing from "../Pages/Common/SchoolLibrary/SchoolLibraryListing/SchoolLibraryListing";
import { List, Users } from "react-feather";
import AllNotifications from "../Pages/Notifications/AllNotifications/AllNotifications";

export const TeacherRoutes = [
  // Teacher Routes

  // All Notifications
  {
    id: "teacher_notifications_details",
    path: "/user/teacher/all-notifications",
    title: "Teacher Notifications",
    layout: "teacher",
    parent: false,
    component: <AllNotifications />,
  },

  // Dashboard
  {
    id: "teacher_dashboard",
    path: "/user/teacher/dashboard",
    title: "Teacher Dashboard",
    layout: "teacher",
    parent: true,
    component: <Dashboard />,
    icon: <List />,
    activeIcon: (
      <i className="fa-solid fa-gauge" style={{ color: "#ffffff" }}></i>
    ),
  },

  // Profile
  {
    id: "teacher_profile",
    path: "/user/teacher/profile",
    title: "Teacher Profile",
    layout: "teacher",
    parent: false,
    component: <Profile />,
    icon: <Users size={18} />,
  },

  // Schools
  {
    id: "teacher_schools_listing",
    path: "/user/teacher/schools",
    title: "Schools",
    layout: "teacher",
    parent: true,
    component: <SchoolsListing />,
    icon: <i className="fas fa-building"></i>,
    activeIcon: (
      <i className="fas fa-building" style={{ color: "#ffffff" }}></i>
    ),
  },

  // Classes And Courses
  {
    id: "teacher_classes_courses",
    path: "/user/teacher/classes",
    title: "Classes And Courses",
    layout: "teacher",
    parent: true,
    component: <ClassesAndCourses />,
    icon: <i className="fas fa-book-reader"></i>,
    activeIcon: (
      <i className="fas fa-book-reader" style={{ color: "#ffffff" }}></i>
    ),
  },
  {
    id: "teacher_courses",
    path: "/user/teacher/classes/details/*",
    title: "Courses",
    layout: "teacher",
    parent: false,
    component: <CoursesListing />,
    icon: <i className="fas fa-book-reader"></i>,
    activeIcon: (
      <i className="fas fa-book-reader" style={{ color: "#ffffff" }}></i>
    ),
  },

  // Attendance
  {
    id: "teacher_attendance_courses",
    path: "/user/teacher/classes/courses/attendance/:id/:id",
    title: "",
    layout: "teacher",
    parent: false,
    component: <Attendance />,
    icon: <i className="fas fa-book-reader"></i>,
    activeIcon: (
      <i className="fas fa-book-reader" style={{ color: "#ffffff" }}></i>
    ),
  },
  {
    id: "teacher_attendance_courses",
    path: "/user/teacher/classes/courses/attendance/add/:id/:id",
    title: "",
    layout: "teacher",
    parent: false,
    component: <AddAttendance />,
    icon: <i className="fas fa-book-reader"></i>,
    activeIcon: (
      <i className="fas fa-book-reader" style={{ color: "#ffffff" }}></i>
    ),
  },
  {
    id: "teacher_attendance_courses",
    path: "/user/teacher/classes/courses/attendance/details/",
    title: "",
    layout: "teacher",
    parent: false,
    component: <PreviousAttendance />,
    icon: <i className="fas fa-book-reader"></i>,
    activeIcon: (
      <i className="fas fa-book-reader" style={{ color: "#ffffff" }}></i>
    ),
  },

  // Exams
  {
    id: "teacher_exams",
    path: "/user/teacher/classes/:id/courses/:id/exams",
    title: "Exams",
    layout: "teacher",
    parent: false,
    component: <ExamListing />,
    icon: <i className="fas fa-book-reader"></i>,
    activeIcon: (
      <i className="fas fa-book-reader" style={{ color: "#ffffff" }}></i>
    ),
  },
  {
    id: "teacher_exams",
    path: "/user/teacher/classes/:id/courses/:id/exams/add",
    title: "Add Exam",
    layout: "teacher",
    parent: false,
    component: <AddExam />,
    icon: <i className="fas fa-book-reader"></i>,
    activeIcon: (
      <i className="fas fa-book-reader" style={{ color: "#ffffff" }}></i>
    ),
  },
  {
    id: "teacher_exams",
    path: "/user/teacher/classes/:id/courses/:id/exams/update/:id",
    title: "Update Exam",
    layout: "teacher",
    parent: false,
    component: <AddExam />,
    icon: <i className="fas fa-book-reader"></i>,
    activeIcon: (
      <i className="fas fa-book-reader" style={{ color: "#ffffff" }}></i>
    ),
  },

  // Results
  {
    id: "teacher_result",
    path: "/user/teacher/classes/:id/courses/:id/exams/:id/result/add",
    title: "Add Result",
    layout: "teacher",
    parent: false,
    component: <AddResult />,
    icon: <i className="fas fa-book-reader"></i>,
    activeIcon: (
      <i className="fas fa-book-reader" style={{ color: "#ffffff" }}></i>
    ),
  },
  {
    id: "teacher_result_view",
    path: "/user/teacher/classes/:id/courses/:id/exams/:id/result/:id",
    title: "View Result",
    layout: "teacher",
    parent: false,
    component: <ExamResult />,
    icon: <i className="fas fa-book-reader"></i>,
    activeIcon: (
      <i className="fas fa-book-reader" style={{ color: "#ffffff" }}></i>
    ),
  },

  // Sports
  {
    id: "teacher_school_sports",
    path: "/user/teacher/sports",
    title: "Sports",
    layout: "teacher",
    parent: true,
    component: <SportsListing />,
    icon: <Users size={18} />,
  },

  // Hostel
  {
    id: "teacher_school_hostel",
    path: "/user/teacher/hostel",
    title: "Hostel",
    layout: "teacher",
    parent: true,
    component: <RoomsListing />,
    icon: <i className="fas fa-hotel"></i>,
    activeIcon: <i className="fas fa-hotel" style={{ color: "#ffffff" }}></i>,
  },

  // Transport
  {
    id: "teacher_school_transport",
    path: "/user/teacher/transport",
    title: "Transport",
    layout: "teacher",
    parent: true,
    component: <TransportsListing />,
    icon: <i className="fas fa-bus"></i>,
    activeIcon: <i className="fas fa-bus" style={{ color: "#ffffff" }}></i>,
  },

  // Holidays
  {
    id: "teacher_school_holidays",
    path: "/user/teacher/holidays",
    title: "Holidays",
    layout: "teacher",
    parent: true,
    component: <HolidaysListing />,
    icon: <i className="fas fa-holly-berry"></i>,
    activeIcon: (
      <i className="fas fa-holly-berry" style={{ color: "#ffffff" }}></i>
    ),
  },

  // Library
  {
    id: "teacher_library_listing",
    path: "/user/teacher/library",
    title: "Library",
    layout: "teacher",
    parent: true,
    component: <SchoolLibraryListing />,
    icon: <i className="fas fa-book"></i>,
    activeIcon: <i className="fas fa-book" style={{ color: "#ffffff" }}></i>,
  },
];
